import { useMemo } from "react";
import { Center, Spinner, Stack, Text } from "@chakra-ui/react";

import { ICard } from "../../../../api/cards/types.ts";
import { useGetCardsQuery } from "../../../../api/cards";
import { EmptyCardListView } from "./EmptyCardListView.tsx";
import { FilledCardListView } from "./FilledCardListView.tsx";

export function CardList() {
  const { data, isPending, isError } = useGetCardsQuery();

  const sortedCards = useMemo(() => {
    const result: { cards: ICard[]; sbp: ICard[] } = {
      cards: [],
      sbp: [],
    };

    if (Array.isArray(data) && data.length !== 0) {
      data.forEach((card) => {
        if (!card.paymentType || !card.productId) {
          return;
        }

        if (card.paymentType === "КАРТА") {
          result.cards.push(card);
        }

        if (card.paymentType === "СБП") {
          result.sbp.push(card);
        }
      });
    }

    return result;
  }, [data]);

  if (isPending) {
    return (
      <Center flex="1" pb="100px">
        <Spinner />
      </Center>
    );
  }

  if (isError) {
    return (
      <Center flex="1" pb="100px">
        <Text variant="brand">Не удалось загрузить данные</Text>
      </Center>
    );
  }

  return (
    <Stack flex="1" w="100%" spacing={0}>
      {
        sortedCards.cards.length === 0 && sortedCards.sbp.length === 0
          ? <EmptyCardListView />
          : <FilledCardListView list={sortedCards} />
      }
    </Stack>
  );
}
